export function isStringEmpty(str) {
  if (typeof str !== 'string' || str.trim().length == 0) {
    return true;
  }

  return false;
}
